import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Dashboard, DashboardPeriod, KeyValuePair } from '../../models';
import { DashboardToPrint } from '../../models/mailing/DashboardToPrint';

// Explicit import on purpose, does not work if imported from common/index
import { dashboardPeriods } from '../../common/dashboardPeriods';
import { languages } from '../../common/';
import { PageOption } from '../../services/helpers/print';

class EmailDashboardSelectorController implements angular.IComponentController {
    dashboards: Dashboard[];
    dashboardsToPrint: DashboardToPrint[];
    formController: angular.IFormController;
    languages: { id: number; key: string; flagIcon: string; text: string; }[];
    options: PageOption[];
    periods: KeyValuePair<DashboardPeriod, string>[];

    static $inject = [];

    $onInit() {
        this.periods = dashboardPeriods
            .map(d => {
                return { key: d.key, value: d.key === DashboardPeriod.None ? '' : d.value };
            });
        this.languages = languages;
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['dashboardsToPrint'] && changesObj['dashboardsToPrint'].currentValue) {
            // In situ update of dashboards to have correct display in drop-down, but keeping original objects for binding...
            this.dashboardsToPrint.forEach(d => {
                if (d.printOptions) {
                    d.printOptions = this.options.find(o => (!o.configuration && !d.printOptions)
                        || (
                            !!o.configuration
                            && !!d.printOptions
                            && o.configuration.orientation === d.printOptions.orientation
                            && d.printOptions.format === o.configuration.format))
                        .configuration;
                }
            });
        }
    }

    add() {
        this.dashboardsToPrint.push({
            printOptions: this.options[0].configuration,
            guid: null,
            period: DashboardPeriod.None,
            language: 'en'
        });

    }

    remove(dashboard: Dashboard, $index: number) {
        this.dashboardsToPrint.splice($index, 1);
        this.formController.$setDirty();
    }
}

export const wtEmailDashboardSelector: ComponentDefinition = {
    componentId: 'wtEmailDashboardSelector',
    controller: EmailDashboardSelectorController,
    template: require('./emailDashboardSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        dashboardsToPrint: '<',
        dashboards: '<',
        options: '<',
        formController: '<?'
    }
};
